<div class="client-page-container">
  <div class="row" style="float: right; padding-right: 15px">
    <div class="col">
      <div class="btn-group flex-wrap gap-2" role="group">
        @for (item of store.categories$ | async; track $index) {

        <button
          (click)="store.selectCategory(item.name)"
          class="category-buttons"
          kendoButton
          size="small"
          [ngClass]="{
            'btn-primary': (store.activeCategory$ | async) == item.name,
            'isg-text-button': (store.activeCategory$ | async) !== item.name
          }"
        >
          {{ item.name }}
          <span
            class="badge ms-2"
            [ngClass]="{
              'bg-light text-primary':
                (store.activeCategory$ | async) == item.name,
              'bg-secondary text-white':
                (store.activeCategory$ | async) !== item.name
            }"
          >
            {{ item.length }}
          </span>
        </button>

        }
      </div>
    </div>
  </div>

  <div class="client-page-header">Action Portal</div>

  <div class="client-page-body" style="padding-top: 10px !important">
    <div class="row">
      <div class="col" style="padding-bottom: 10px !important">
        <div class="btn-group flex-wrap gap-2" role="group">
          @for (item of subCategories$ | async; track $index) {
          <button
            (click)="store.selectSubCategory(item.label)"
            class="category-buttons"
            kendoButton
            size="small"
            [ngClass]="{
              'btn-primary': item.label == (activeSubCategory$ | async)?.label,
              'isg-text-button':
                item.label != (activeSubCategory$ | async)?.label
            }"
          >
            {{ item.label }}
            <span
              class="badge ms-2"
              [ngClass]="{
                'bg-light text-primary':
                  item.label == (activeSubCategory$ | async)?.label,
                'bg-secondary text-white':
                  item.label != (activeSubCategory$ | async)?.label
              }"
            >
              {{ item.length }}
            </span>
          </button>

          }
        </div>
      </div>
    </div>
    @if ((activeTableConfig$ | async)?.length) {
    <div class="row">
      <kendo-grid
        [kendoGridBinding]="(dataSource$ | async) || []"
        [pageSize]="5"
        (pageChange)="pageChange($event)"
        [skip]="skip"
        [pageable]="{
          buttonCount:10,
          info:true,
          pageSizes:true,
          previousNext:true,
          responsive:true,
          position: 'bottom'
        }"
        [pageSize]="pageSize"
        [style.height]="'100%'"
        [selectable]="{ checkboxOnly: true, mode: 'multiple' }"
        [kendoGridSelectBy]="'id'"
      >
        <ng-template kendoGridToolbarTemplate>
          <input placeholder="Search..."
                kendoTextBox
                (input)="onFilter($any($event).target)" />
          <!-- <kendo-grid-spacer></kendo-grid-spacer>
          <button kendoGridExcelCommand type="button" title="Export to Excel">
            <span class="fas fa-file-excel"></span>
          </button> -->
        </ng-template>
        <kendo-grid-checkbox-column [width]="50"></kendo-grid-checkbox-column>

        <kendo-grid-column title="Actions" [width]="190">
          <ng-template kendoGridCellTemplate let-row>
            <div
              *ngIf="(activeSubCategory$ | async)?.metaData as TableInfo"
              class="d-flex align-items-center k-custom-font-size"
            >
              @if (row.approve_action_label) {
              <button
                class="btn btn-success btn-sm me-2"
                (click)="openConfirmationDialog(row, TableInfo, 'approve')"
              >
                {{ row.approve_action_label || "Approve" }}
              </button>
              } @if(row.reject_action_label) {
              <button
                class="btn btn-danger btn-sm me-2"
                (click)="openConfirmationDialog(row, TableInfo, 'reject')"
              >
                {{ row.reject_action_label || "Reject" }}
              </button>
              } @if(row.hasClarification) {
              <button class="btn btn-outline-white btn-sm me-2">
                <i class="fa fa-question-circle-o"></i>
              </button>
              }
              <button
                class="btn btn-outline-white btn-sm"
                (click)="openAttachmentDialog(row, TableInfo)"
              >
                <i
                  [class]="
                    row.has_attachments
                      ? 'text-success fw-bold fa fa-paperclip'
                      : 'fa fa-paperclip'
                  "
                ></i>
              </button>
            </div>
          </ng-template>
        </kendo-grid-column>

        @for (item of activeTableConfig$ | async; track $index) {
        <kendo-grid-column
          [field]="item.key"
          [title]="item.label"
          [width]="130"
        >
        </kendo-grid-column>
        }

        <ng-template kendoPagerTemplate
                   let-totalPages="totalPages"
                   let-currentPage="currentPage">
          <div class="custom-pager">
            <div class="custom-pager-pagesize">View&nbsp;&nbsp; <kendo-dropdownlist [data]="sizes" [(ngModel)]="pageSize" (valueChange)="pageSizeChange($event)"></kendo-dropdownlist></div>
            <div class="custom-pager-jump"><kendo-pager-input #input></kendo-pager-input></div>
            <div class="custom-pager-items"><kendo-pager-prev-buttons></kendo-pager-prev-buttons> {{startnum()}} - {{endnum(((dataSource$ | async) || []).length)}} of {{((dataSource$ | async) || []).length}} <kendo-pager-next-buttons></kendo-pager-next-buttons></div>
          </div>
        </ng-template>
      </kendo-grid>
    </div>
    }
  </div>
</div>
